module.exports = "../../../../platform/assets/pageMainIcon/ig-business-setting-8.svg";